<script lang="ts" setup>
defineOptions({
    inheritAttrs: false
});

defineProps({
    text: {
        type: String,
        default: ''
    },
    sub: {
        type: String,
        default: ''
    },
    iconLeft: {
        type: String,
        default: null
    },
    tooltip: {
        type: String,
        default: ''
    },
    selected: {
        type: Boolean,
        default: false
    },
    wrapText: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    dataTest: {
        type: String,
        default: 'popup-menu'
    },
    iconSize: {
        type: Number,
        default: 20
    }
});
</script>

<template>
    <span v-tooltip="tooltip">
        <button
            :disabled="disabled"
            :title="text"
            v-bind="$attrs"
            class="sy-popup-menu-button button-reset flex-container align-middle"
            :class="[{ 'active' : selected, 'sy-not-allowed' : disabled }]"
            :data-test="dataTest"
        >
            <slot>
                <div class="sy-popup-menu-icon">
                    <Icon
                        v-if="iconLeft != null"
                        :icon="iconLeft"
                        :size="iconSize"
                        class="margin-right-3 sy-icon-transition"
                    />
                </div>
                <div class="text-truncate">
                    <p class="sy-type-standard" :class="[ wrapText ? 'sy-pre-wrap' : 'sy-truncate']">{{ text }}</p>
                    <p class="sy-type-small" :class="[ wrapText ? 'sy-pre-wrap' : 'sy-truncate']">{{ sub }}</p>
                </div>
            </slot>
        </button>
    </span>
</template>
